export default "__VITE_ASSET__BpnYndXG__"